import { Link } from 'react-router-dom';

const links = [
  {
    to: '/projetos-corporativos',
    titulo: 'Projetos corporativos',
    texto: 'Soluções completas para ambientes corporativos, do planejamento à entrega.',
    icon: 'ri-building-4-line',
  },
  {
    to: '/divisorias',
    titulo: 'Divisórias corporativas',
    texto: 'Vidro, MDF e soluções modulares para organizar ambientes.',
    icon: 'ri-layout-masonry-line',
  },
  {
    to: '/cabines-acusticas',
    titulo: 'Cabines acústicas',
    texto: 'Soluções para conforto sonoro e privacidade no ambiente de trabalho.',
    icon: 'ri-volume-up-line',
  },
];

export default function IntegracaoSection() {
  return (
    <section className="bg-white">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div>
            <p className="text-[12px] md:text-[13px] font-semibold tracking-[0.28em] uppercase text-primary-500 mb-4">
              Integração
            </p>
            <h2 className="text-foreground-950 text-[28px] md:text-[40px] font-semibold tracking-tight leading-tight mb-6">
              Carpete, mobiliário e divisórias no mesmo projeto.
            </h2>
            <p className="text-foreground-500 text-[15px] md:text-[16px] leading-relaxed mb-6">
              A Home Office Premium integra diferentes soluções em um único projeto, reduzindo a
              fragmentação entre fornecedores e garantindo maior coerência entre layout, mobiliário,
              divisórias, piso e acústica.
            </p>
            <a
              href="/projetos-corporativos"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white text-[14px] font-semibold px-6 py-3.5 rounded-full transition-colors whitespace-nowrap cursor-pointer"
            >
              Analisar meu projeto completo
              <i className="ri-arrow-right-line text-base"></i>
            </a>
          </div>

          <div className="space-y-4">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="group flex items-start gap-4 bg-background-50 border border-background-200/60 rounded-2xl p-5 hover:border-primary-300 transition-colors"
              >
                <span className="w-11 h-11 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 flex-shrink-0">
                  <i className={`${l.icon} text-xl`}></i>
                </span>
                <div className="flex-1">
                  <p className="text-foreground-900 text-[15px] font-semibold group-hover:text-primary-600 transition-colors">
                    {l.titulo}
                  </p>
                  <p className="text-foreground-500 text-[13px] leading-relaxed mt-1">{l.texto}</p>
                </div>
                <i className="ri-arrow-right-line text-foreground-300 group-hover:text-primary-500 group-hover:translate-x-1 transition-all text-lg mt-1"></i>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}